// Search toggle
function toggleSearch() {
  document.getElementById('searchBar').classList.toggle('open');
  if (document.getElementById('searchBar').classList.contains('open')) {
    document.getElementById('searchInput').focus();
  }
}

// Mobile menu toggle
function toggleMobileMenu() {
  document.getElementById('mobileMenu').classList.toggle('open');
}

// Close on Escape
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    document.getElementById('searchBar').classList.remove('open');
    document.getElementById('mobileMenu').classList.remove('open');
  }
});

// Add to cart via Shopify AJAX (for product cards on listing pages)
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('btn-add') && e.target.form) return; // let form handle it
});
